EditCategoriasDirective.$inject = [];
export default function EditCategoriasDirective() {
    return {
        restrict: 'E',
        controller: 'EditCategoriasCtrl as vm',
        template: require('./edit-categorias.html'),
        scope: {
            tareaPeriodicaId: '@',
            categoriasIds: '@',
            callback: '&'
        },
        bindToController: true
    };
}